import { Component, inject } from '@angular/core';
import { TranslateService, TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ConnectionStateService } from './core/connection-state.service';
import { MkdeAlertHolderDirective } from './alert/mkde-alert-holder.directive';
import {
  NgbModal,
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
} from '@ng-bootstrap/ng-bootstrap';
import { AboutDialogComponent } from './about-dialog/about-dialog.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  imports: [
    RouterLink,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    TranslateDirective,
    TranslatePipe,
  ],
})
export class AppHeaderComponent {
  protected alerts = inject(MkdeAlertHolderDirective);
  protected translateService = inject(TranslateService);
  protected connectionStateService = inject(ConnectionStateService);
  protected modalService = inject(NgbModal);

  public languages: string[] = ['de', 'fr'];

  private languageNames: { [key: string]: string } = {
    de: 'Deutsch',
    fr: 'Français',
  };

  public constructor() {
    document.body.classList.add('close-navigation');
  }

  public shortLanguageName(): string {
    return this.translateService.currentLang.toUpperCase();
  }

  public languageName(language: string): string {
    return this.languageNames[language] || language;
  }

  public openAboutDialog(): void {
    this.modalService.open(AboutDialogComponent, { size: 'md' });
  }
}
